export function poll(pollee, initialDelay) {
    let timeoutId;
    let isActive = true;
    function stop() {
        isActive = false;
        clearTimeout(timeoutId);
    }
    async function nextPoll() {
        try {
            const delay = await pollee(stop);
            if (!isActive || typeof delay !== 'number') {
                return;
            }
            timeoutId = setTimeout(nextPoll, delay);
        }
        catch {
        }
    }
    if (Number.isFinite(initialDelay)) {
        timeoutId = setTimeout(nextPoll, initialDelay);
    }
    else {
        nextPoll();
    }
    return stop;
}
